import { Link, TableCell, TableRow } from '@ksyos/design-system';
import { isEmpty } from 'lodash';
import type { IEmploymentCarePaths } from './PersonalSettingsCarePathsOverview';
import { translateKey } from '../../../../translate';

interface IPersonalSettingsCarePathOverviewDetailsInactiveCareGroupFoldOutProps {
    inactiveCarePaths: IEmploymentCarePaths;
    showInactiveCareGroups: boolean;
    toggleShowInactiveCarePaths: () => void;
}

export function PersonalSettingsCarePathOverviewDetailsInactiveCareGroupFoldOut(
    props: IPersonalSettingsCarePathOverviewDetailsInactiveCareGroupFoldOutProps
) {
    if (isEmpty(props.inactiveCarePaths)) {
        return null;
    }

    return (
        <TableRow key={'inactiveCareGroups-link'}>
            <TableCell colSpan={5}>
                <Link
                    color="subtle"
                    fontWeight="normal"
                    iconLeft={props.showInactiveCareGroups ? 'caret-up' : 'caret-down'}
                    my={2}
                    onClick={props.toggleShowInactiveCarePaths}
                    size="xs"
                    variant="button"
                >
                    {props.showInactiveCareGroups
                        ? translateKey('episodeCategory.foldInactiveCarePath')
                        : translateKey('episodeCategory.showInactiveCarePath')}
                </Link>
            </TableCell>
        </TableRow>
    );
}
